export enum PlaylistType {
  Section = 'section',
  SameCast = 'cast',
  SameGenre = 'genre',
  Theater = 'theater',
  Genres = 'genres',
}
